import React from 'react';
import Markdown from './pages/Markdown';

function App() {
  return (
    <>
      <div>
        <p style={{ textAlign: 'center', padding: "40px", background: "#140101c7", fontSize: "30px", color: "white", }}>REACT | MARKDOWN 😃</p>
      </div>
      <Markdown />

    </>
  );
}

export default App;
